import type { CTA_Button } from '@/modules/Content/interface/CTA_Button';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useGetCTAProgram = (slug: string) =>
  useQuery({
    queryKey: ['program', 'cta', slug],
    queryFn: () => getCTAProgram(slug),
    enabled: !!slug,
  });

const getCTAProgram = async (slug: string) => {
  const { data } = await api.get<CTA_Button>(
    apiConfig.routes.entertainment.program.cta(slug)
  );
  return data;
};
